import { render } from "./back-to-game-page.svg?vue&type=template&id=65f9f518"
const script = {}
script.render = render

export default script